import AppliedProducts from '../AppliedProducts/AppliedProducts';
import FloorplanSummayCard from '../FloorplanSummaryCard/FloorplanSummaryCard';
import ProgressBar from '../ProgressBar/ProgressBar';
import RoomsceneSwitcher from '../RoomsceneSwitcher/RoomsceneSwitcher';
import StepsController from '../StepsController/StepsController';
import VisualizerPage from '../VisualizerPage/VisualizerPage';

export default function TestPage() {
    return(
        <>
        <div style={{width: 100+"%"}}>
        
        <FloorplanSummayCard
            name="Augusta"
            beds="2"
            baths="4"
            sqft="3100"
            cars="2"
        />
        <RoomsceneSwitcher />
        <ProgressBar
            progress="20"
        />
        <StepsController />
        <AppliedProducts />
        <VisualizerPage />

        </div>
        </>
    );
}